// All app paths in one place.

export const paths = {
  splash: '/',
  authLanding: '/login',
  loginEmail: '/login/email',
  loginOtp: '/login/otp',
  oauthGoogleCallback: '/oauth/google/callback',
  oauthFacebookCallback: '/oauth/facebook/callback',

  onboarding: '/onboarding',
  onboardingProfile: '/onboarding/profile',
  onboardingPassport: '/onboarding/passport',
  onboardingNationalityPicker: '/onboarding/passport/nationality',
  onboardingFillLater: '/onboarding/fill-later',
  onboardingFamilyEmpty: '/onboarding/family',
  onboardingFamilyForm: '/onboarding/family/new',
  onboardingFamilyRole: '/onboarding/family/new/role',
  onboardingFamilyList: '/onboarding/family/list',
  onboardingPaymentEmpty: '/onboarding/payment',
  onboardingPaymentCards: '/onboarding/payment/cards',
  onboardingEvacuation: '/onboarding/evacuation',
  onboardingEvacuationCountries: '/onboarding/evacuation/countries',
  onboardingSubscribePitch: '/onboarding/subscribe',
  onboardingAllSet: '/onboarding/done',

  home: '/home',
  newsFeed: '/home/news',
  newsArticle: (id = ':id') => `/home/news/${id}`,
  bookingOptions: (id = ':id') => `/booking/${id}/options`,
  boardingPass: (id = ':id') => `/booking/${id}/pass`,
  boardingActions: (id = ':id') => `/booking/${id}/actions`,

  wallet: '/wallet',
  walletTopup: '/wallet/topup',
  moneyLink: (token = ':token') => `/t/${token}`,
  payIntent: (intentId = ':intentId') => `/pay/${intentId}`,
  subscribePlans: '/subscribe',
  subscribePayment: (planCode = ':planCode') => `/subscribe/${planCode}/pay`,
  subscribeAddCard: '/subscribe/add-card',
  subscribeSuccess: '/subscribe/success',
  subscribeError: '/subscribe/error',

  travel: '/travel',
  travelDetail: (id = ':id') => `/travel/tour/${id}`,
  travelFlightSearch: '/travel/flights',

  notifications: '/notifications',

  business: '/business',
  businessCreate: '/business/create',
  businessSearch: '/business/search',
  businessDetail: (id = ':id') => `/business/${id}`,
  businessCabinet: '/business/cabinet',

  settings: '/settings',
  settingsPriorityEdit: '/settings/priorities',
  settingsFamilyEdit: '/settings/family',
  settingsPassportEdit: '/settings/passport',
  settingsLanguage: '/settings/language',
  settingsPolicies: '/settings/policies',
  settingsPolicyView: (kind = ':kind') => `/settings/policies/${kind}`,
  settingsEvacuation: '/settings/evacuation',

  support: '/support',
  supportNew: '/support/new',
  supportTicket: (id = ':id') => `/support/${id}`,

  notFound: '/404',
  error: '/error',
} as const;
